import styles from './ImpactBadge.module.css'

export type ImpactLevel = 'high' | 'elevated' | 'moderate' | 'low'

/** DESIGN_SPEC: 75+ solid navy · 65–74 navy ring · 50–64 grey ring · <50 grey fill. */
export function impactLevel(score: number): ImpactLevel {
  if (score >= 75) return 'high'
  if (score >= 65) return 'elevated'
  if (score >= 50) return 'moderate'
  return 'low'
}

const LABEL: Record<ImpactLevel, string> = { high: 'high', elevated: 'elevated', moderate: 'moderate', low: 'low' }

export interface ImpactBadgeProps {
  score: number | null
  size?: 'sm' | 'md'
}

export function ImpactBadge({ score, size = 'md' }: ImpactBadgeProps) {
  if (score === null) {
    return <span className={`${styles.badge} ${styles[size]} ${styles.none}`} title="Not scored">—<span className="sr-only">Not scored</span></span>
  }
  const s = Math.max(0, Math.min(100, Math.round(score)))
  const level = impactLevel(s)
  return (
    <span className={`${styles.badge} ${styles[size]} ${styles[level]}`} data-level={level} title={`Impact ${s} of 100 (${LABEL[level]})`}>
      <span aria-hidden="true">{s}</span>
      <span className="sr-only">Impact {s} of 100, {LABEL[level]}</span>
    </span>
  )
}
